import React from 'react';
export var TabSetContext = React.createContext();